/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Full_TextInputs */

const en_read_along_ai_full_text = /** @type {(inputs: Read_Along_Ai_Full_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full available text`)
};

const es_read_along_ai_full_text = /** @type {(inputs: Read_Along_Ai_Full_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el texto disponible`)
};

/**
* | output |
* | --- |
* | "Full available text" |
*
* @param {Read_Along_Ai_Full_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_full_text = /** @type {((inputs?: Read_Along_Ai_Full_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Full_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_full_text(inputs)
	return en_read_along_ai_full_text(inputs)
});